import React, { Component } from 'react';
import firebase from 'firebase';
import { Line, Pie } from 'react-chartjs-2';


const database = firebase.database();

class ChartLine extends Component {

	constructor(props) {
		super(props);
		this.state = {
			data: {},
		}
	}


	componentWillMount() {
		// Extraer nombre de ultimos 3 meses
		const today = new Date();
		let months = new Array('Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre');
		let curMonth = months[today.getMonth()];
		let curMonth1 = months[today.getMonth(today.setMonth(today.getMonth() - 1))];
		let curMonth2 = months[today.getMonth(today.setMonth(today.getMonth() - 1))];

		let arreglo = { mes1: 0, mes2: 0, mes3: 0 };

		firebase.database().ref('/Viaje').once('value').then(snap => {
			snap.forEach(el => {
				let id = el.val().id;
				let data = el.val();
				if (data.fechaBajada) {

					// Extraer meses
					let today = new Date();
					let now = new Date();
					now.setMonth(now.getMonth() -1);
					const mesUno = `${today.getFullYear()}-${today.getMonth() + 1}`;
					const mesDos = `${now.getFullYear()}-${now.getMonth() +1}`;
					const mesTres = `${now.getFullYear()}-${now.getMonth()}`;

					// Extraer fecha registro
					const fecha = new Date(data.fechaBajada);
					const fechaEl = `${fecha.getFullYear()}-${fecha.getMonth() +1}`;

					if (fechaEl === mesUno) {
						arreglo.mes1 = parseInt(arreglo.mes1) + 1;
					}else if (fechaEl === mesDos) {
						arreglo.mes2 = parseInt(arreglo.mes2) + 1;
					}else if (fechaEl === mesTres) {
						arreglo.mes3 = parseInt(arreglo.mes3) + 1;
					}
				}
			});
			this.setState({
				data: {
					labels: [curMonth2, curMonth1, curMonth],
					datasets: [
						{
							label: 'Usuarios registrados',
							fill: true,
							lineTension: 0,
							backgroundColor: 'rgba(138,221,45,0.4)',
							borderColor: 'rgba(138,221,45,1)',
							borderCapStyle: 'butt',
							borderDash: [],
							borderDashOffset: 0.0,
							borderJoinStyle: 'miter',
							pointBorderColor: 'rgba(138,221,45,1)',
							pointBackgroundColor: 'black',
							pointBorderWidth: 1,
							pointHoverRadius: 5,
							pointHoverBackgroundColor: 'rgba(138,221,45,1)',
							pointHoverBorderColor: 'rgba(220,220,220,1)',
							pointHoverBorderWidth: 2,
							pointRadius: 1,
							pointHitRadius: 10,
							data: [arreglo.mes3, arreglo.mes2, arreglo.mes1],
						}
					]
				}
			});
		});
	}

	render() {
		return (
			<div className="chart_line">
				<Line data={this.state.data} />
			</div>
		)
	}
}

export default ChartLine;


// WEBPACK FOOTER //
// ./src/Components/Charts/ChartLine.js